module.exports = "/_next/static/images/b3b8dec39ae0a7111d4685b3652d08b2-card-xs.png.webp";